module.exports = __webpack_public_path__ + "static/media/avatar-default.6abfc1fd.svg";